import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-otp.css";
import FooterButton from "../../components/ui/Button/FooterButton";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useOTP } from "../../hooks/useOTP";
import Header from "../Header/stepHeader";

const OtpInput = ({
  title,
  pageData,
  step = "2",
  onOtpSuccess,
  phoneNumber,
  onBack,
  allowOtpByPass = false,
  isFetchOtpOnFirstRender = false,
}) => {
  const { t } = useTranslation("loanProcessForm");
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const {
    otpValues,
    handleOtpChange,
    handleKeyDown,
    inputRefs,
    fetchNewOtp,
    handleVerifyOtp,
  } = useOTP({
    onOtpSuccess: () => {
      if (!onOtpSuccess) return;
      onOtpSuccess();
    },
    pageData,
    msisdn: phoneNumber,
    allowOtpByPass,
    isFetchOtpOnFirstRender,
  });

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div id="PageOtp">
        <Header
          title={title || t("verifyTitle")}
          showIcon={false}
          onBack={onBack}
          step={step}
        />
        <div
          className="wrapContent"
          style={{ paddingTop: isDesktop ? "120px" : "100px" }}
        >
          <div id="pOtp">
            <div className="bContent">
              <div className="bOtp">
                <div className="bImg">
                  <img src="/assets/img/ci/icon/phone1.svg" alt="Success" />
                </div>
                <div className="bInfo">
                  <div className="bTop">
                    <div className="bText">
                      <p>{t("otpSentMessage")}</p>
                    </div>
                    <div className="bInput">
                      {otpValues.map((value, index) => (
                        <input
                          key={index}
                          ref={(el) => (inputRefs.current[index] = el)}
                          value={value}
                          onChange={(e) => handleOtpChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          maxLength={1}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="bMiddle">
                    <p>{t("didNotReceiveOtp")}</p>
                    <span
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={fetchNewOtp}
                    >
                      {t("resend")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterButton
        onSubmit={handleVerifyOtp}
        onBack={handleBack}
        submitButtonTitle={t("confirmOtp")}
        backButtonTitle={t("back")}
      />
    </>
  );
};

export default OtpInput;
